module.exports = __webpack_public_path__ + "img/berkley_logo.eb1a8d55.png";